export class IndexPool {
  readonly capacity: number;
  readonly active: Uint8Array;
  private readonly free: Int32Array;
  private freeTop: number;
  count = 0;

  constructor(capacity: number) {
    if (!Number.isInteger(capacity) || capacity <= 0) throw new RangeError('capacity must be a positive integer');
    this.capacity = capacity;
    this.active = new Uint8Array(capacity);
    this.free = new Int32Array(capacity);
    this.freeTop = capacity;
    for (let i = 0; i < capacity; i += 1) this.free[i] = capacity - 1 - i;
  }

  acquire(): number {
    if (this.freeTop === 0) return -1;
    const nextTop = this.freeTop - 1;
    const index = this.free[nextTop] ?? -1;
    this.freeTop = nextTop;
    this.active[index] = 1;
    this.count += 1;
    return index;
  }

  release(index: number): boolean {
    if (index < 0 || index >= this.capacity || this.active[index] === 0) return false;
    this.active[index] = 0;
    this.free[this.freeTop] = index;
    this.freeTop += 1;
    this.count -= 1;
    return true;
  }

  reset(): void {
    this.active.fill(0);
    this.freeTop = this.capacity;
    this.count = 0;
    for (let i = 0; i < this.capacity; i += 1) this.free[i] = this.capacity - 1 - i;
  }
}
